module.exports = __webpack_public_path__ + "static/media/sjsu_logo.d7303f35.png";